import React, { useState, useEffect, useCallback } from "react";

interface NaviInterface {
  name: string;
}

const whereAmI = (activeName: string, myName: string): string => {
  if (activeName === myName) {
    return "active dropdown";
  }

  return "dropdown";
};

export const Navigation = ({ name }: NaviInterface) => {
  const [isTopMenuActiv, setIsTopMenuActiv] = useState(false);

  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    event.preventDefault();
    setIsTopMenuActiv(!isTopMenuActiv);
  };

  return (
    <header className={name === "popular" ? "absolute" : ""}>
      <nav className={"left-nav navbar"}>
        <div className="sidebar-part1">
          <a
            href="/"
            title="Beralink"
            className="logo padding-15px-all md-no-padding sm-no-padding"
          >
            <img
              src="./images/logo.png"
              data-at2x="images/logo@2x.png"
              alt="Beralink"
            />
          </a>
        </div>
        <div className="sidebar-part2">
          <div className="sidebar-middle">
            <div className="sidebar-middle-menu font-weight-600">
              <nav className="navbar bootsnav navbar-expand-lg no-margin">
                <div id="navbar-menu" className="navbar-collapse">
                  <ul className="nav navbar-nav margin-80px-bottom mx-0">
                    <li className={whereAmI("", name)}>
                      <a href="/" title="Home">
                        NFT<i className="fas fa-home pull-right"></i>
                      </a>
                    </li>
                    {/* <li className={whereAmI("dashboard", name)}>
                      <a href="/dashboard" title="Wallet">
                        WALLET<i className="fas fa-wallet pull-right"></i>
                      </a>
                    </li> */}
                    <li className={whereAmI("planet", name)}>
                      <a href="/planet" title="Planet">
                        PLANET<i className="fas fa-rocket pull-right"></i>
                      </a>
                    </li>
                    <li className={whereAmI("tiers", name)}>
                      <a href="/universe" title="Universe">
                        TOPLIST<i className="fas fa-star pull-right"></i>
                      </a>
                    </li>
                    <li className={whereAmI("crypto", name)}>
                      <a href="/orbit" title="Orbit">
                        TOKEN
                        <i className="icon-bolt fas fa-bolt pull-right"></i>
                      </a>
                    </li>
                    {/* <li className={whereAmI("mint", name)}>
                      <a href="/nova" title="in-mint-proess">
                        MINT
                        <i className="icon-bolt fas fa-gavel pull-right"></i>
                      </a>
                    </li> */}
                    <li className={whereAmI("popular", name)}>
                      <a href="/popular" title="Popular">
                        POPULAR
                        <i className="fas fa-heart pull-right mr-[6px]"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </nav>

              <div className="header-sidebar-wrap">
                <div
                  id="pofo_social_widget-4"
                  className="widget widget_pofo_social_widget"
                >
                  <div className="widget-title"></div>
                  <div className="flex justify-center gap-[10px]">
                    <a
                      href="https://opensea.io/collection/beralink-astro"
                      target="_blank"
                    >
                      <img
                        width="36"
                        src="./images/opensea.png"
                        alt="opensea"
                      ></img>
                    </a>
                    <a href="https://x.com/Bera_link" target="_blank">
                      <img
                        width="35"
                        src="./images/twitter.png"
                        alt="twitter"
                      ></img>
                    </a>
                    <a href="https://discord.gg/beralink" target="_blank">
                      <img
                        width="36"
                        src="./images/discord.png"
                        alt="discord"
                      ></img>
                    </a>
                  </div>
                </div>
              </div>
              <div className="right-bg">
                <img src="./images/slogan.png" alt="Beralink" />
              </div>
            </div>
          </div>
        </div>
        <div className="sidebar-part3">
          <div onClick={(e) => e.preventDefault()} className="bottom-menu-icon">
            <a
              href="#"
              onClick={handleClick}
              className={
                isTopMenuActiv === false
                  ? "right-menu-button text-extra-dark-gray nav-icon"
                  : "right-menu-button text-extra-dark-gray nav-icon active"
              }
              id="showRightPush"
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};
